import { useNavigate } from 'react-router-dom';

export const useExportModalController = () => {
	const navigate = useNavigate();

	const navigateToExportPage = async () => {
		navigate('/exports');
	};

	return {
		navigateToExportPage,
	};
};
